import type { ReactNode } from 'react';

export function Notice({ title, children, tone = 'info' }: { title: string; children: ReactNode; tone?: 'info' | 'warning' | 'danger' }) {
  return (
    <div className={`notice ${tone === 'info' ? '' : tone}`} role={tone === 'danger' ? 'alert' : 'note'}>
      <span aria-hidden="true">{tone === 'danger' ? '!' : tone === 'warning' ? '△' : 'i'}</span>
      <div><strong>{title}</strong>{children}</div>
    </div>
  );
}
